import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "./ui/Button";
import { Icon } from "./ui/Icon";

interface BackLinkProps {
  to?: string;
  label?: string;
}

export function BackLink({ to = "/", label = "Retour" }: BackLinkProps) {
  const navigate = useNavigate();
  const location = useLocation();
  // « Retour » revient à l'écran d'origine quand on a navigué DANS l'app
  // (ex. Personnes → capture : retour = Personnes, retour QA). `key ===
  // "default"` = première entrée d'historique (arrivée directe, deep-link,
  // magic link) : aucun écran app derrière → repli sur le lien `to`.
  const canGoBack = location.key !== "default";

  /* `secondary` (mauve doux = action de structure/navigation, DS §6.2) pour
     un bouton en évidence ; `self-start` empêche l'étirement pleine largeur
     quand le parent est un conteneur `flex-col` (retour QA). */
  const inner = (
    <Button
      variant="secondary"
      size="sm"
      className="self-start"
      onClick={canGoBack ? () => navigate(-1) : undefined}
    >
      <Icon name="arrow-left" size={16} />
      {label}
    </Button>
  );

  if (canGoBack) return inner;
  return (
    <Link to={to} className="contents">
      {inner}
    </Link>
  );
}
